// src/components/SessionEdit.js
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import Header from './Header';
import Footer from './Footer';
import { useI18n } from '../i18n/I18nContext';
import { getComponentCopy } from '../i18n/componentCopy';

const SessionEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { language } = useI18n();
  const copy = getComponentCopy(language);
  const [sessionData, setSessionData] = useState({
    sessionName: '',
    description: '',
    date: '',
    startTime: '',
    price: ''
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  // Fetch the session details
  useEffect(() => {
    const fetchSession = async () => {
      try {
        const docRef = doc(db, 'availableSessions', id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setSessionData(docSnap.data());
        } else {
          setError(copy.notFound);
        }
      } catch (err) {
        setError(copy.fetchError);
      } finally {
        setLoading(false);
      }
    };
    fetchSession();
  }, [copy.fetchError, copy.notFound, id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    try {
      const sessionRef = doc(db, 'availableSessions', id);
      await updateDoc(sessionRef, sessionData);
      setMessage(copy.updated);
    } catch (err) {
      console.error(err);
      setError(copy.updateError);
    }
  };

  if (loading) {
    return (
      <>
        <Header />
        <div style={{ padding: '20px' }}>{copy.loadingSession}</div>
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <Header />
        <div style={{ padding: '20px' }}>{error}</div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <div style={{ padding: '20px' }}>
        <h1>{copy.edit}</h1>
        {message && <div className="market-success" role="status">{message}</div>}
        {error && <div className="market-alert" role="alert">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div>
            <label>{copy.sessionName}</label>
            <input
              type="text"
              value={sessionData.sessionName}
              onChange={(e) => setSessionData({ ...sessionData, sessionName: e.target.value })}
              required
            />
          </div>
          <div>
            <label>{copy.description}</label>
            <textarea
              value={sessionData.description}
              onChange={(e) => setSessionData({ ...sessionData, description: e.target.value })}
              required
            />
          </div>
          <div>
            <label>{copy.date}</label>
            <input
              type="date"
              value={sessionData.date}
              onChange={(e) => setSessionData({ ...sessionData, date: e.target.value })}
              required
            />
          </div>
          <div>
            <label>{copy.startTime}</label>
            <input
              type="time"
              value={sessionData.startTime}
              onChange={(e) => setSessionData({ ...sessionData, startTime: e.target.value })}
              required
            />
          </div>
          <div>
            <label>{copy.price}</label>
            <input
              type="number"
              value={sessionData.price}
              onChange={(e) => setSessionData({ ...sessionData, price: parseFloat(e.target.value) })}
              min="0"
              step="0.01"
              required
            />
          </div>
          <button type="submit">{copy.update}</button>
          {message && <button type="button" onClick={() => navigate('/teller-dashboard')}>{copy.dashboard}</button>}
        </form>
      </div>
      <Footer />
    </>
  );
};

export default SessionEdit;
